import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import {Response} from 'src/app/services/models/response.model'
import { Transaction } from './models/transaction/transaction.model';
import { BatchCancelRequest } from './models/transaction/batch.cancel.request.model';
import { TransactionGetRequest } from './models/transaction/transaction.get.request.model';

@Injectable()
export class TransationService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.transaction;
  }

  searchTransaction(data:string): Observable<Response<Transaction[]>>{
    const url = `/SearchTransaction?request=` + encodeURIComponent(data);
    return this.get(url)
    .map(result => new Response<Transaction[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getTransactionDetail(data: TransactionGetRequest): Observable<Response<any>> {
    return this.post(`/GetTransactionDetail`, data, {})
    .map(result => new Response<any>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  batchHistory(data:string): Observable<Response<Transaction[]>>{
    const url = `/BatchHistory?request=` + encodeURIComponent(data);
    return this.get(url)
    .map(result => new Response<Transaction[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  batchDetail(data:string): Observable<Response<Transaction[]>>{
    const url = `/BatchDetail?request=` +  encodeURIComponent(data);
    return this.get(url)
    .map(result => new Response<Transaction[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  cancelBatch(logindetail: BatchCancelRequest): Observable<Response<any>> {
    return this.post(`/CancelBatch`, logindetail, {})
    .map(result => new Response<any>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateTransaction(data: any): Observable<Response<any>> {
    return this.post(`/UpdateTransaction`, data, {})
    .map(result => new Response<any>(result.code, result.message, result.responseData))
    .catch(this.handleError);
  }
}